import { AxiosResponse } from "axios";
import {
  CreateAccountLinksOpts,
  CreateConnectedAccountOpts,
  CreateRefundExternalizedOpts,
  RefundOpts,
  RetryRefundExternalizedOpts,
} from "../../../models/Api/Refund";
import { axiosInstance } from "../../../../../axiosInstance";

export const createRefund = async ({
  orderId,
  orderItemId,
  reason,
}: RefundOpts): Promise<AxiosResponse> => {
  const body = {
    order_id: orderId,
    ...(reason && {
      reason,
    }),
    ...(orderItemId && {
      order_item_id: orderItemId,
    }),
  };

  return axiosInstance.post(`/payment/refund`, body);
};

/**
 * create a refund with the payment externalization
 *
 * @return - A promise resolves create a refund
 */
export const createRefundExternalized = async (
  payload: CreateRefundExternalizedOpts
): Promise<AxiosResponse> => {
  let path = `/global_orders/${payload.globalOrderId}/orders/${payload.orderId}`;

  if (payload.orderItemId) path += `/order_items/${payload.orderItemId}`;

  path += "/refund_request";

  let body = {};
  if (payload.reason) {
    body = { reason: payload.reason };
  }

  return axiosInstance.post(path, body);
};

/**
 * retry a refund request with the payment externalization
 *
 * @return - A promise resolves retry a refund request
 */
export const retryRefundExternalized = async (
  payload: RetryRefundExternalizedOpts
): Promise<AxiosResponse> => {
  return axiosInstance.post(`/webhook_events/${payload.id}`);
};

/**
 * create connected account
 *
 * @return - A promise resolves create connected account
 */
export const createConnectedAccount = async (
  payload: CreateConnectedAccountOpts
): Promise<AxiosResponse> => {
  return axiosInstance.post(`/payment/connect/accounts/${payload.id}`);
};

/**
 * create account links
 *
 * @return - A promise resolves create account links
 */
export const createAccountLinks = async (
  payload: CreateAccountLinksOpts
): Promise<AxiosResponse> => {
  return axiosInstance.post(`/payment/connect/account_links/${payload.id}`, {
    refresh_url: payload.refreshUrl,
    return_url: payload.returnUrl,
  });
};
